package com.routexk.quiz.ui.sections.header.components

import androidx.compose.runtime.Composable
import com.routexk.quiz.ui.sections.header.NavLinkStyle
import com.routexk.quiz.ui.theme.AppColors
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.browser.document
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Text

@Composable
internal fun NavLink(path: String, text: String, onClick: (() -> Unit)? = null) {
    val colorMode = ColorMode.current
    val colors = AppColors.getColors(colorMode)

    A(
        href = path,
        attrs = NavLinkStyle
            .toModifier()
            .color(colors.textPrimary)
            .textDecorationLine(TextDecorationLine.None)
            .onClick {
                it.preventDefault()
                onClick?.invoke() ?: run {
                    document.querySelector(path)?.scrollIntoView(
                        js("{ behavior: 'smooth' }")
                    )
                }
            }
            .toAttrs()
    ) {
        Text(text)
    }
}
